module.exports = __webpack_public_path__ + "media/images/partners/ansi-f2c745cc34c5fef452a734d3a9a17668.png";